import { render, staticRenderFns } from "./OtherInformation.vue?vue&type=template&id=4c8694af&scoped=true&"
import script from "./OtherInformation.vue?vue&type=script&lang=js&"
export * from "./OtherInformation.vue?vue&type=script&lang=js&"
import style0 from "./OtherInformation.vue?vue&type=style&index=0&id=4c8694af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8694af",
  null
  
)

export default component.exports